'use strict';

const headerNavSubItemTokens = (theme) => ({
    headerNavSubItemPaddingX: theme.space.component.x.m,
    headerNavSubItemPaddingY: theme.space.component.y.m,
    headerNavSubItemBackgroundColor: theme.colors.body.background,
    headerNavSubItemHoverBackgroundColor: theme.palette.grey100,
});

exports.headerNavSubItemTokens = headerNavSubItemTokens;
//# sourceMappingURL=headerNavSubItem.js.map
